import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import { ApiStatusCodes } from 'services/api/apiStatusCode';
import { allocator } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';
import { IFetchRequirementsPayload } from 'types/discovery/AgencyDiscovery.types';

import {
  fetchRequirements,
  fetchRequirementsFailed,
  fetchRequirementsSucceeded,
} from '../../slice/discovery/AgencyDiscovery.slice';

function* fetchRequirementsSaga(
  action: PayloadAction<IFetchRequirementsPayload>
): Generator<any, void, any> {
  try {
    const { agencyId, allocatorId } = action.payload;

    const result = yield HTTPClient.GetRequest(
      allocator.GET_ALLOCATOR_REQUIREMENTS(agencyId, allocatorId)
    );

    const { data, status } = result;

    if (status === ApiStatusCodes.SUCCESS && data) {
      yield put(fetchRequirementsSucceeded(data));
    } else {
      throw new Error();
    }
  } catch (error) {
    yield put(
      fetchRequirementsFailed({
        error: {
          message: 'An error occurred while fetching allocator requirements.',
        },
      })
    );
  }
}

export function* watchAgencyDiscoverySaga() {
  yield takeLatest(fetchRequirements.type, fetchRequirementsSaga);
}
